"use client";

import EmblaCarousel from "@/components/ui/embla-carousel/embla-carousel";
import styles from "./collaboration-blurb.module.scss";

function CollaborationBlurb() {
  const OPTIONS = { loop: true };
  const SLIDES = [
    {
      src: "/collaboration_carousel/carousel_profile.png",
      text: "Register and make your profile visible to others!",
    },
    {
      src: "/collaboration_carousel/carousel_map.png",
      text: "Access GIS- and AI-made map layers to gain insights about peatland condition factors!",
    },
    {
      src: "/collaboration_carousel/carousel_directory.png",
      text: "Establish connection with projects and organisations involved in peatland restoration, conservation and monitoring, and much more!",
    },
    {
      src: "/collaboration_carousel/carousel_glossary.png",
      text: "Familiarise with peatland terms maintained by the Peat Hub Ireland project",
    },
    {
      src: "/collaboration_carousel/carousel_wish.png",
      text: "Share your needs and help others, collaborate to preserve and restore peatlands!",
    },
  ];
  return (
    <section className={styles.blurbContainer}>
      <h2 className={styles.blurbTitle}>
        Join us and Collaborate with Others!
      </h2>
      <p className={styles.blurbDescription}>
        Register your account today to unlock more content. Here’s a glimpse of
        that what PeatSense offers:
      </p>
      <EmblaCarousel slides={SLIDES} options={OPTIONS} />
    </section>
  );
}

export default CollaborationBlurb;
